module.exports = __webpack_public_path__ + "img/product-preview-63.ce87685.png";